import { useLocalObservable } from 'mobx-react-lite';

import { IDiscoverDestination } from 'APP/model/tenantRouter/tenantRouterModel.types';
import Entities from 'STORE';

import { ILoginViewProps } from '../../Login.types';
import { LoginAddNewServerStep } from '../LoginAddNewServerStep/LoginAddNewServerStep';

export interface ILoginServerSelectStepProps extends ILoginViewProps {}

interface ILoginServerSelectStepPresenterParams extends ILoginServerSelectStepProps {}

interface ILoginServerSelectStepPresenter {
  serversDestinations: IDiscoverDestination[];
  onSubmit(key: string): void;
  onAddNewServer(): void;
  onBackHandler: (() => void) | null;
}

export function useLoginServerSelectStepPresenter(
  params: ILoginServerSelectStepPresenterParams
): ILoginServerSelectStepPresenter {
  const { loginPresenter } = params;
  const presenter = useLocalObservable<ILoginServerSelectStepPresenter>(() => ({
    get serversDestinations(): IDiscoverDestination[] {
      return Entities.authStore.serversDestinations;
    },

    async onSubmit(key: string): Promise<void> {
      await loginPresenter.onAuthorizeWithNewConfig(key);
      if (loginPresenter.error) {
        presenter.onAddNewServer();
      }
    },

    onAddNewServer(): void {
      loginPresenter.openView(LoginAddNewServerStep);
    },

    get onBackHandler(): (() => void) | null {
      if (!loginPresenter.onBackHandler) {
        return null;
      }

      return () => {
        loginPresenter.setDestinationKey('');
        loginPresenter.onBackHandler?.();
      };
    },
  }));

  return presenter;
}
